<div class="permission-wrapper">
  <div class="heading-wrapper">
    <h2>{{ 'myAccount.permissions.title' | cxTranslate }}</h2>
    <span> {{ 'myAccount.permissions.details' | cxTranslate }} </span>
  </div>
  @if (permissionList$ | async; as data) {
  <div class="myaccount-permission-wrapper">
    @for (enum of data.enums; track enum) {
    <mat-checkbox
      #permissionCheckbox
      class="permission-checkbox"
      [disabled]="checkValue(enum)"
      [checked]="compareValue(enum, this.permissionCodes, permissionCheckbox)"
      [value]="enum"
      disableRipple
      (change)="onChangeEventFunc(enum.code, $event)"
    >
      {{ enum.name }}
      <span [innerHtml]="getTranslation(enum.code) | async"></span>
    </mat-checkbox>
    }
  </div>
  } @else {
  <div class="spinner-container">
    <mat-spinner [diameter]="72"></mat-spinner>
  </div>
  }
</div>
